var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts_wrap"},[_c('div',{ref:"wrapper",staticClass:"basic-guage-2"})])
}
var staticRenderFns = []

export { render, staticRenderFns }